__turbopack_context__.v({
  "container": "TaxUnitModal-module-scss-module__D1qXGa__container",
  "error": "TaxUnitModal-module-scss-module__D1qXGa__error",
  "inputContainer": "TaxUnitModal-module-scss-module__D1qXGa__inputContainer",
  "selectorContainer": "TaxUnitModal-module-scss-module__D1qXGa__selectorContainer",
  "ssnValidation": "TaxUnitModal-module-scss-module__D1qXGa__ssnValidation",
  "typeSelector": "TaxUnitModal-module-scss-module__D1qXGa__typeSelector",
});
